import React, {useState, useEffect} from 'react'

import './LoginPage.scss'

import { connect } from 'react-redux'

import { Link, useHistory, useLocation } from "react-router-dom";

import asideVideo from '../../videos/vid1.mp4'
import Axios from 'axios'
import { hostDetect } from '../../config/envConfig'


function LoginPage({userLogin}) {

  const [passwordType, setPasswordType] = useState('password')
  const [email, setEmail] = useState({wasChanged: false, value: ''})
  const [password, setPassword] = useState({wasChanged: false, value: ''})
  const [emailError, setEmailError] = useState(false)
  const [passwordError, setPasswordError] = useState(false)
  const [loginError, setLoginError] = useState({status: false, message: ''})
  const [submitButtonDisabled, setSubmitButtonDisabled] = useState(false)

  const history = useHistory();

  const location = useLocation();
  let blockTeaser = false;
  if(location.pathname === '/block-teaser'){
    blockTeaser = true;
  }

  useEffect(()=>{
    if(email.value && email.value.length > 0){
      setEmailError(false);
    } else if(email.wasChanged){
      setEmailError(true);
    }
  },[email])

  useEffect(()=>{
    if(password.value && password.value.length > 0){
      setPasswordError(false);
    } else if(password.wasChanged){
      setPasswordError(true);
    }
  },[password])

  const handleEmailInput = (e) => {
    let emailValue = e.target.value;
    setEmail({wasChanged: true, value: emailValue})
  }

  const handlePasswordInput = (e) => {
    let passwordValue = e.target.value;
    setPassword({wasChanged: true, value: passwordValue})
  }



  const submitForm = (e) => {

    e.preventDefault();

    setLoginError({status: false, message: ''})

    if(!email.value){
      setEmailError(true);
    }
    if(!password.value){
      setPasswordError(true);
    }

    if(email.value && password.value){
      setSubmitButtonDisabled(true)

      let formData = new FormData();
      formData.append('email', email.value)
      formData.append('password', password.value)


      Axios.post(`${hostDetect('api')}/users/login`, formData, { withCredentials: true })
      .then(res => {
        let success = res.data.success;
        if(success){

          // ---login for localhost
          // userLogin(true)
          // setSubmitButtonDisabled(false)
          // history.push("/");

          // ---for cookies
          Axios.post(`https://api.svk-native.ru/users/login`, formData, { withCredentials: true }).then(res2 => {
            let success2 = res2.data.success;

            if(success2){
              userLogin(true)
              setSubmitButtonDisabled(false)
              if(!blockTeaser){
                history.push("/");
              }
            } else {
              userLogin(false)
              setLoginError({status: true, message: res2.data.data.message})
              setSubmitButtonDisabled(false)
            }

          }).catch(err => {
            setLoginError({status: true, message: 'Не удалось отправить запрос. Обновите страницу и попробуйте снова.'})
            setSubmitButtonDisabled(false)
          })
          

          
        } else {
          userLogin(false)
          setLoginError({status: true, message: res.data.data.message})
          setSubmitButtonDisabled(false)
        }
      })
      .catch(err => {
        setLoginError({status: true, message: 'Не удалось отправить запрос. Обновите страницу и попробуйте снова.'})
        setSubmitButtonDisabled(false)
      })
    }
    
  }

  return (
    <div className="sign-section">
      <div className="sign-section__wrap">
        <div className="sign-section__left">
          <div className="container-sign">
            <div className="sign-section__left-wrap">
              <div className="sign-section__header">
                <div className="sign-section__logo">
                  <a href="https://sparrow.ru">
                    <svg 
                      width="151" 
                      height="30" 
                      viewBox="0 0 151 30" 
                      fill="none" 
                      xmlns="http://www.w3.org/2000/svg">
                        <path d="M100.346 21.8535C107.18 21.8535 110.807 17.4206 111.689 11.8197C111.701 11.794 111.819 10.7695 111.83 10.6591L113.128 0H103.022C95.7159 0 91.5515 6.03495 91.5515 12.802C91.5515 18.5776 95.0778 21.8535 100.346 21.8535ZM103.555 4.14592C105.668 4.14592 107.379 5.88228 107.379 8.02514C107.379 10.168 105.668 11.9044 103.555 11.9044C101.445 11.9044 99.7318 10.168 99.7318 8.02514C99.7318 5.88228 101.445 4.14592 103.555 4.14592ZM147.176 14.095C149.287 14.095 151 15.8314 151 17.9742C151 20.1171 149.287 21.8535 147.176 21.8535C145.064 21.8535 143.353 20.1171 143.353 17.9742C143.353 15.8314 145.064 14.095 147.176 14.095ZM8.11321 21.8535C13.1697 21.8535 16.357 19.1386 16.357 15C16.357 11.6818 14.1505 10.1606 10.9179 8.53464C9.01246 7.57633 7.9863 6.89761 7.9863 6.20785C7.9863 5.38749 8.7949 4.89454 9.64339 4.91478C10.6206 4.93501 12.0656 5.47394 13.2114 7.06867L17.0785 3.36235C15.2093 1.07787 12.4046 0 9.60169 0C5.3103 0 1.91091 2.80135 1.91091 7.02636C1.91091 10.1294 3.83451 11.8363 6.96739 13.4476C9.35512 14.6781 10.1964 15.0441 10.1964 15.8185C10.1964 16.5524 9.38776 16.9828 8.28363 16.9828C6.67006 16.9828 4.80085 15.9914 3.568 14.4831L0 18.2336C1.8257 20.5604 5.13988 21.8535 8.11321 21.8535ZM20.5287 0.388105L16.919 30H23.2917L24.4375 20.4739L24.608 20.4316C25.8825 21.4231 27.4979 21.8535 29.4505 21.8535C35.0164 21.8535 39.393 16.1202 39.393 8.62109C39.393 3.83691 37.1413 0 32.8082 0C30.1739 0 28.0926 1.37952 26.5624 3.6217L26.5207 3.53525L26.9014 0.388105H20.5287ZM27.7517 16.1202C26.6476 16.1202 25.5852 15.6898 24.947 14.8271L24.9905 14.2679C25.4111 8.71306 28.3464 5.73329 30.6833 5.73329C32.1283 5.73329 33.0203 7.24157 33.0203 9.26671C33.0203 12.7578 31.1928 16.1202 27.7517 16.1202ZM47.6096 21.8535C49.9466 21.8535 52.0279 20.5604 53.5563 18.3182L53.685 18.3624L53.3024 21.4654H59.7169L62.2659 0.388105H55.8515L55.6811 1.85408H55.5542C54.4501 0.689761 52.8347 0 50.6681 0C45.2291 0 40.8543 5.73329 40.8543 13.2324C40.8543 18.103 43.1478 21.8535 47.6096 21.8535ZM49.6492 16.1202C48.2043 16.1202 47.2687 14.7848 47.2687 12.7578C47.2687 9.61251 48.9693 5.7756 51.7723 5.7756C53.0903 5.7756 54.2796 6.29246 55.2133 7.28387L55.1281 7.88719C54.383 13.1864 51.8575 16.1202 49.6492 16.1202ZM65.1033 0.395463L62.5542 21.4654H68.9269L69.8606 13.363C70.4408 8.34335 73.1748 6.0423 76.2334 7.16248L77.1272 0C74.8319 0 72.7923 1.12017 71.1787 3.2759H71.0935L71.476 0.395463H65.1033ZM79.6618 0.395463L77.1127 21.4654H83.4854L84.4209 13.363C84.9993 8.34335 87.7351 6.0423 90.7936 7.16248L91.6856 0C89.3922 0 87.3525 1.12017 85.7371 3.2759H85.6519L86.0345 0.395463H79.6618ZM119.339 21.8535C121.76 21.8535 124.43 20.5162 125.917 18.0166H126.002C126.597 20.2587 128.381 21.8535 131.688 21.8535C137.076 21.8535 142.288 18.6125 143.648 9.0515C144.065 6.11404 144.114 3.103 143.648 0.388105H137.247C137.587 3.14715 137.575 5.25874 137.247 7.75843C136.393 14.2643 134.11 16.0779 132.75 16.0779C131.561 16.0779 131.187 14.9577 131.561 11.897L132.962 0.388105H126.809L125.705 9.35316C125.067 14.5236 122.815 16.0779 121.633 16.0779C120.273 16.0779 119.969 14.5254 120.358 11.6376L121.881 0.388105H115.601L113.815 13.1459C113.099 18.2685 114.921 21.8535 119.339 21.8535Z" fill="#46A3F3"></path>
                    </svg>
                  </a>
                </div>
              </div>
              <div className="sign-section__body">
                <h1>Вход в личный кабинет</h1>
                <div className="sign-section__form">
                  {/* <form> */}
                    <div className={"sign-form__field sign-form__field--done sign-form__field--with-icon " + (emailError ? 'sign-form__field--error' : '')}>
                      <span className="sign-form__icon sign-form__icon--email">
                        <svg width="18" height="18" viewBox="0 0 25 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M20.8268 0H3.60562C1.9037 0 0.461388 1.21154 0.115234 2.82692L12.2306 10.2115L24.3172 2.82692C23.971 1.21154 22.5287 0 20.8268 0Z" fill="#565656"></path><path d="M12.9231 12.0865C12.6923 12.2308 12.4327 12.2885 12.2019 12.2885C11.9712 12.2885 11.7115 12.2308 11.4808 12.0865L0 5.07693V14.3942C0 16.3846 1.61538 18 3.60577 18H20.8269C22.8173 18 24.4327 16.3846 24.4327 14.3942V5.07693L12.9231 12.0865Z" fill="#565656"></path>
                        </svg>
                      </span>
                      <div className="sign-form__field-input-wrap">
                        <input type="text" name="email" id="email" maxLength="101" value={email.value} onChange={handleEmailInput} autoComplete="true" required />
                        <span className="floating-placeholder">Email</span>
                      </div>
                      {
                        emailError ? <p className="sign-form__field-error">Заполните это поле</p> : null
                      }
                    </div>
                    <div className={"sign-form__field sign-form__field--with-icon password-field sign-form__field--done " + (passwordError ? 'sign-form__field--error' : '')}>
                      <span className="sign-form__icon sign-form__icon--password">
                        <svg 
                          width="12" 
                          height="24" 
                          viewBox="0 0 18 24" 
                          fill="none" 
                          xmlns="http://www.w3.org/2000/svg">
                            <path d="M17.5 9H16V6.99998C16 3.14016 12.8599 0 9 0C5.14012 0 2.00002 3.14016 2.00002 6.99998V9H0.500016C0.223641 9 0 9.22364 0 9.50002V22C0 23.103 0.896953 24 2.00002 24H16C17.103 24 18 23.103 18 22V9.50002C18 9.22364 17.7764 9 17.5 9ZM10.4971 19.4448C10.5127 19.5859 10.4673 19.7275 10.3726 19.8335C10.2779 19.9395 10.1421 20 10 20H8.00002C7.85794 20 7.72219 19.9395 7.62745 19.8335C7.53272 19.7276 7.4873 19.586 7.50295 19.4448L7.81838 16.6084C7.30617 16.2359 7.00003 15.6465 7.00003 15C7.00003 13.897 7.89698 13 9.00005 13C10.1031 13 11.0001 13.8969 11.0001 15C11.0001 15.6465 10.6939 16.2359 10.1817 16.6084L10.4971 19.4448ZM13 9H5.00002V6.99998C5.00002 4.79442 6.79444 3 9 3C11.2056 3 13 4.79442 13 6.99998V9Z" fill="#565656"></path>
                        </svg>
                      </span>
                      <span className="sign-form__icon sign-form__icon--right sign-form__icon--eye" onClick={()=> passwordType === 'password' ? setPasswordType('text') : setPasswordType('password')}>
                        <svg 
                          width="18" 
                          height="19" 
                          viewBox="0 0 27 19" 
                          fill="none" 
                          xmlns="http://www.w3.org/2000/svg">
                            <path d="M13.5003 5.52271C11.4691 5.52271 9.81848 7.17337 9.81848 9.20452C9.81848 11.2357 11.4691 12.8863 13.5003 12.8863C15.5314 12.8863 17.1821 11.2357 17.1821 9.20452C17.1821 7.17337 15.5314 5.52271 13.5003 5.52271Z" fill="#565656"></path>
                            <path d="M13.5 0C7.36363 0 2.1232 3.81677 0 9.20453C2.1232 14.5922 7.36363 18.4091 13.5 18.4091C19.6425 18.4091 24.8768 14.5922 27 9.20453C24.8768 3.81677 19.6425 0 13.5 0ZM13.5 15.3408C10.1127 15.3408 7.36363 12.5917 7.36363 9.20447C7.36363 5.81721 10.1127 3.06816 13.5 3.06816C16.8873 3.06816 19.6364 5.81726 19.6364 9.20453C19.6364 12.5918 16.8873 15.3408 13.5 15.3408Z" fill="#565656"></path>
                        </svg>
                      </span>
                      <div className="sign-form__field-input-wrap">
                        <input type={passwordType} name="password" id="password" maxLength="101" value={password.value} onChange={handlePasswordInput} autoComplete="true" required/>
                        <span className="floating-placeholder">Пароль</span>
                      </div>
                      {
                        passwordError ? <p className="sign-form__field-error">Заполните это поле</p> : null
                      }
                    </div>

                    {
                      loginError.status ? (
                        <div className="message-status message-status--error">
                          {
                            loginError.message
                          }
                        </div>) : null
                    }


                    <button type="submit" className="sign-form__submit-btn" onClick={submitForm} disabled={submitButtonDisabled}>Войти</button>

                    <div className="d-flex align-items-center justify-content-between">
                      <a href="https://sparrow.ru/sign-up.html?role=1" style={{fontWeight: 500, color: '#46a3f3'}}>Регистрация</a>
                      <a href="https://sparrow.ru/forgot-password.html" className="sign-form__password-reset-link">Забыли пароль?</a>
                    </div>

                  {/* </form> */}
                </div>
                
              </div>
            </div>
          </div>
        </div>

        <div className="sign-section__right">
          <div className="sign-section__right-video-wrap">
            <div className="video-phone-wrap">
              <video autoPlay muted data-keepplaying loop>
                <source src={asideVideo} type="video/mp4" />
              </video>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

function mapDispatchToProps(dispatch){
  return {
    userLogin: logged => dispatch({type: 'LOGIN_USER', payload: logged})
  }
}

export default connect(null, mapDispatchToProps)(LoginPage);